export const instructions_array = [
  'Colour print your downloaded pdf file and bring it to Sir Adamjee Institute, FB Area, Hussainabad, Khi.',
  'Come along with fees i.e. 6999/- and which is complete fees of 6 months course. ( FEES IS NON REFUNDABLE )',
  'Classes of this Life Changing Course starting from Sunday 5th Nov 23 in your selected Day and timings.',
  'We have very limited seats available so come in between 5pm to 9pm (Mon to Sun) to submit fees'

]


